import { Link } from "react-router-dom";

const km = (m) => (m >= 1000 ? `${(m / 1000).toFixed(2)} km` : `${Math.round(m)} m`);

export function LocateResults({ results, onSelect, selected }) {
  if (!results) return null;
  if (!results.count) {
    return <p className="mt-4 text-sm text-neutral-500" data-testid="locate-no-results">No photos with GPS inside this area.</p>;
  }
  return (
    <div className="mt-4 space-y-4" data-testid="locate-results">
      <div className="grid grid-cols-3 border-2 border-black">
        {[["PHOTOS", results.count + (results.truncated ? "+" : "")], ["SESSIONS", results.sessions.length], ["SPREAD (EST.)", `${results.acres} ac`]].map(([l, v], i) => (
          <div key={l} className="px-3 py-2 border-r-2 border-black last:border-r-0" data-testid={`locate-stat-${i}`}>
            <p className="label-mono text-[10px] text-neutral-500">{l}</p>
            <p className="font-mono text-lg font-bold">{v}</p>
          </div>
        ))}
      </div>
      <ul className="border-2 border-black divide-y-2 divide-black" data-testid="locate-session-list">
        {results.sessions.map((s) => (
          <li key={s.id} className="px-3 py-2 flex items-center justify-between gap-3">
            <span className="min-w-0"><span className="block font-mono text-sm font-bold truncate">{s.name}</span><span className="block font-mono text-[11px] text-neutral-500">{s.count} photos</span></span>
            <Link to={`/survey?session=${s.id}`} className="btn-flat-outline text-xs" data-testid={`locate-open-survey-${s.id}`}>Survey</Link>
          </li>
        ))}
      </ul>
      <ul className="border-2 border-black max-h-80 overflow-auto divide-y divide-white/10" data-testid="locate-photo-list">
        {results.photos.slice(0, 200).map((p) => (
          <li key={p.id}>
            <button onClick={() => onSelect(p)} className={`w-full text-left px-3 py-2 font-mono text-xs flex justify-between gap-3 hover:bg-white/5 ${selected === p.id ? "bg-white/10" : ""}`} data-testid={`locate-photo-${p.id}`}>
              <span className="truncate">{p.filename} <span className="text-neutral-500">· {p.session_name}</span></span>
              <span className="text-neutral-500 shrink-0">{p.distance_m != null ? km(p.distance_m) : p.alt != null ? `${p.alt} m alt` : ""}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
